import { getBorderRadius, getFont } from '@24i/nxg-sdk-higgs';
import { Theme } from '@24i/nxg-sdk-photon';
import { IconButtonWebStyles } from '../../IconButton/types';

const ActionButton = (theme: Theme): IconButtonWebStyles => ({
    holder: {
        width: 'auto',
        height: 54,
        borderRadius: 27,
        backgroundColor: theme.color.buttonPrimary,
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row',
        marginRight: 12,
        minWidth: 52,
        paddingLeft: 18,
        paddingRight: 27,
        ...getBorderRadius(theme.elements, 'buttonPrimary-cornerRadius'),
        '@media (max-width: 1200px)': {
            height: 52,
            borderRadius: 26,
            paddingLeft: 16,
            paddingRight: 24,
            ...getBorderRadius(theme.elements, 'buttonPrimary-cornerRadius'),
        },
        transition: 'opacity 0.15s ease-out',
        pressed: { opacity: 0.7 },
        hovered: { opacity: 0.8 },
    },
    holderDisabled: {
        opacity: 0.4,
    },
    text: {
        color: theme.color.textButtonPrimary,
        marginLeft: 10,
        textTransform: 'uppercase',
        ...getFont(theme, 'primaryButton'),
    },
});
export default ActionButton;
